import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientUpdateService {
  private reloadClient$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  public reloadClientObservable$: Observable<void> = this.reloadClient$.asObservable();

  public triggerReload(): void {
    this.reloadClient$.next();
  }
}
